export default __webpack_public_path__ + "static/media/stopSign2.aadce0e9.jpeg";